var boostPFS = new BoostPFS();
boostPFS.init(); 
if (typeof boostPFSConfig != 'undefined'
	&& typeof boostPFSConfig.general != 'undefined' 
	&& typeof boostPFSConfig.general.isInitFilter != 'undefined'
	&& typeof boostPFSThemeConfig != 'undefined'
	&& boostPFSConfig.general.isInitFilter === true) {
	boostPFS.initFilter();
} 
BoostPFS.jQ(window).on('load', function(){
	boostPFS.initSearchBox();
	false && boostPFS.initAnalytics();
    let boostToogleSw = document.getElementById('boost-pfs-toggleSwitch');
    let instockElement = document.querySelector('span[aria-labelledby="In Stock"]');
    if (boostToogleSw) {
      boostToogleSw.addEventListener('change', function() {
        let selected = false;
        document.querySelectorAll('.boost-pfs-filter-option-stock-status .boost-pfs-filter-option-label').forEach(element => {
          if (element.classList.contains('selected')) {
            selected = true;
            return;
          }
        });
        if (selected) {
          if (boostToogleSw.checked) {
            if (instockElement && !instockElement.hasAttribute("aria-checked")) {
              document.querySelector('span[aria-labelledby="In Stock"]').click();
            }
            document.querySelector('span[aria-labelledby="Out Of Stock"]').click();
          } else {
            document.querySelector('span[aria-labelledby="Out Of Stock"]').click();
          }
        } else {
          if (boostToogleSw.checked) {
            document.querySelector('span[aria-labelledby="In Stock"]').click();
            document.querySelector('span[aria-labelledby="Out Of Stock"]').click();
          } else {
            document.querySelector('span[aria-labelledby="In Stock"]').click();
          }
        }
      });
    }
    const queryString = window.location.href;
    if (queryString.includes("pf_st_stock_status=false")) {
      boostToogleSw.checked = true;
    } else {
      if (!queryString.includes("pf_st_stock_status=true") && document.querySelector('span[aria-labelledby="In Stock"]')) {
        document.querySelector('span[aria-labelledby="In Stock"]').click();
      }
    }
    let clearoutstock = document.querySelector('button[aria-label="Clear filter by Stock Status Out Of Stock"]');
    if(clearoutstock){
      clearoutstock.addEventListener('click', function() {
       boostToogleSw.checked = false;
      });
    }
});